module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cxUuf"))).then(() => parcelRequire('hEqeo'));